module.exports = __webpack_public_path__ + "img/resource-tech-image-57.996f9fea.jpg";